import clsx from "clsx";
import Cookies from "js-cookie";
import React from "react";
import { Dropdown, Flex } from "antd";
import type { MenuProps } from "antd";
import { useHistory, useLocation } from "react-router-dom";

import ArrowUp from "~/components/Icons/arrow-up";
import {
  MainNavItem,
  MainNavSubmenuItem,
} from "~/components/Layout/Header/lib/buildMainNav";

import s from "./NavItem.less";

export const NavItem = ({ item }: { item: MainNavItem }) => {
  const history = useHistory();
  const location = useLocation();

  const isActive = (route: string) => {
    if (route === "/") return location.pathname === "/";
    return location.pathname.startsWith(route);
  };

  const navigate = (route: string) => (info: any) => {
    const domEvent = info.domEvent || info;
    const isMetaPressed = domEvent.ctrlKey || domEvent.metaKey;
    if (isMetaPressed) {
      window.open(route, "_blank");
      return;
    }
    history.push(route);
  };

  const openCandidateLink = (path: string) => () => {
    const base = (process.env.REACT_APP_CANDIDATE_LINK || "").replace(
      /\/+$/,
      "",
    );
    if (!base) return;
    const token = Cookies.get("token");
    const tokenParam = token ? `?token=${encodeURIComponent(token)}` : "";
    window.open(`${base}${path}${tokenParam}`, "_blank", "noopener,noreferrer");
  };

  if (item.submenu && item.submenu.length > 0) {
    const matches = item.submenu.filter((sub) => isActive(sub.route));
    const bestMatch = matches.reduce<MainNavSubmenuItem | null>(
      (best, sub) =>
        !best || sub.route.length > best.route.length ? sub : best,
      null,
    );
    const isDropdownActive = !!bestMatch;
    const activeKeys = bestMatch ? [bestMatch.route] : [];

    const items: MenuProps["items"] = item.submenu.map(
      (sub: MainNavSubmenuItem) => ({
        key: sub.route,
        label: (
          <div
            className={s.subMenuItem}
            style={{ cursor: "pointer", userSelect: "none" }}
          >
            {sub.title}
          </div>
        ),
        onClick: sub.href ? openCandidateLink(sub.href) : navigate(sub.route),
        style: { cursor: "pointer" },
      }),
    );

    return (
      <Dropdown
        menu={{ items, selectedKeys: activeKeys }}
        overlayClassName={s.overlay}
      >
        <Flex
          gap={4}
          align={"center"}
          className={clsx(s.mainNavItem, s.dropdown, {
            [s.active]: isDropdownActive,
          })}
        >
          <span>{item.title}</span>
          <ArrowUp fill={"#fff"} />
        </Flex>
      </Dropdown>
    );
  }

  return (
    <span
      className={clsx(s.mainNavItem, { [s.active]: isActive(item.route) })}
      onClick={navigate(item.route)}
    >
      {item.title}
    </span>
  );
};
